// extracted by mini-css-extract-plugin
export default {"statusChip":"StatusChip_statusChip__Hl3y2","completed":"StatusChip_completed__4zVxt","toDo":"StatusChip_toDo__1N+29","inProgress":"StatusChip_inProgress__lATgm"};